// @flow
import * as React from 'react';
import { ModalContainer, ModalInnerTitle } from '../../components';

type Props = {
	onClick: Function,
	text: string,
	header_text: string
};

export const TextModal = ({ onClick, text, header_text }: Props) => (
	<ModalContainer header_text={header_text} onClick={onClick}>
		<ModalInnerTitle>
			{text}
		</ModalInnerTitle>
	</ModalContainer>
);

export default TextModal;


// WEBPACK FOOTER //
// ./src/components/Modal/TextModal.js